import Icon from "../icons/Icon";
// src/components/dashboard/OtApprovalCard.js
// Dashboard card — pending OT approval queue summary.
// Visibility gated by `time:ot:view` via src/config/dashboardCards.js.
// Component returns null if otSummary hasn't loaded yet (mirrors original
// `canSeeOT && otSummary` render guard).

export const OtApprovalCard = ({ otSummary, navigate, company }) => {
  if (!otSummary) return null;

  return (
    <div className="dashboard-card">
      <div className="dashboard-card__header">
        <span className="dashboard-card__title">OT Approval</span>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate(`/company/${company.slug}/ot-approval`);
          }}
          className="dashboard-card__link"
        >
          View All →
        </a>
      </div>
      {otSummary.pending > 0 ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            padding: 16,
            background: "var(--ui-warning-tint)",
            borderRadius: 10,
            marginBottom: 16,
            cursor: "pointer",
          }}
          onClick={() => navigate(`/company/${company.slug}/ot-approval`)}
        >
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 10,
              background: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              fontSize: 20,
            }}
          >
            <Icon name="hourglass" size={20} />
          </div>
          <div style={{ flex: 1 }}>
            <div
              style={{
                fontSize: 28,
                fontWeight: 700,
                color: "var(--ui-warning-text)",
                fontVariantNumeric: "tabular-nums",
                lineHeight: 1,
              }}
            >
              {otSummary.pending}
            </div>
            <div style={{ fontSize: 13, color: "var(--ui-warning-text)", fontWeight: 500 }}>
              Pending Approval
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            padding: 16,
            textAlign: "center",
            color: "var(--ui-text-muted)",
            fontSize: 14,
          }}
        >
          No pending OT records
        </div>
      )}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 12,
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "12px 8px",
            background: "var(--ui-bg)",
            borderRadius: 8,
          }}
        >
          <div
            style={{
              fontSize: 18,
              fontWeight: 700,
              color: "var(--ui-primary-hover)",
              fontVariantNumeric: "tabular-nums",
            }}
          >
            {otSummary.approved || 0}
          </div>
          <div style={{ fontSize: 11, color: "var(--ui-text-muted)", fontWeight: 500 }}>
            Approved
          </div>
        </div>
        <div
          style={{
            textAlign: "center",
            padding: "12px 8px",
            background: "var(--ui-bg)",
            borderRadius: 8,
          }}
        >
          <div
            style={{
              fontSize: 18,
              fontWeight: 700,
              color: "var(--ui-primary-hover)",
              fontVariantNumeric: "tabular-nums",
            }}
          >
            {otSummary.autoApproved || 0}
          </div>
          <div style={{ fontSize: 11, color: "var(--ui-text-muted)", fontWeight: 500 }}>
            Auto-Approved
          </div>
        </div>
        <div
          style={{
            textAlign: "center",
            padding: "12px 8px",
            background: "var(--ui-bg)",
            borderRadius: 8,
          }}
        >
          <div
            style={{
              fontSize: 18,
              fontWeight: 700,
              color: "var(--ui-danger)",
              fontVariantNumeric: "tabular-nums",
            }}
          >
            {otSummary.rejected || 0}
          </div>
          <div style={{ fontSize: 11, color: "var(--ui-text-muted)", fontWeight: 500 }}>
            Rejected
          </div>
        </div>
      </div>
    </div>
  );
};